import {BarChart, Bar, CartesianGrid, Legend} from 'recharts'
import './index.css'
import Header from '../Header'
import MoodTrackerContext from '../../context/MoodTrackerContext'

const Reports = () => (
  <MoodTrackerContext.Consumer>
    {value => {
      const {
        calenderList,
        emojisListNew,
        onReportCalenderChange,
        calenderReportList,
        reportCalenderMonth,
      } = value

      return (
        <>
          <Header />
          <div className="reports-body-container">
            <h1 className="emoji-report-heading">Overall Emojis Reports</h1>
            <ul className="emoji-report-ul">
              {emojisListNew.map(item => (
                <li className="emoji-report-li" key={item.id}>
                  <p className="emoji-li-para">{item.emojiName}</p>
                  <img
                    className="emoji-li-img"
                    src={item.emojiUrl}
                    alt={item.emojiName}
                  />

                  <p className="emoji-count">{item.count}</p>
                </li>
              ))}
            </ul>
            <div className="monthly-container">
              <h1 className="monthly-reports-heading">Monthly Reports</h1>
              <select
                value={reportCalenderMonth}
                onChange={onReportCalenderChange}
                className="calender-select"
              >
                {calenderList.map(item => (
                  <option key={item.month} value={item.month}>
                    {item.monthName}
                  </option>
                ))}
              </select>
            </div>
            {console.log(calenderReportList[0])}

            <BarChart
              className="bar-chart"
              width={350}
              height={250}
              data={calenderReportList}
              margin={{top: 20, right: 30, left: 20, bottom: 5}}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <Legend />
              <Bar dataKey="count" fill="#ffbe38" barSize={30}>
                {calenderReportList.map((entry, index) => (
                  <img
                    key={entry.id}
                    src={entry.emojiUrl}
                    alt={`emoji-${index}`}
                    style={{width: '20px', height: '20px', marginRight: '10px'}}
                  />
                ))}
              </Bar>
            </BarChart>
          </div>
        </>
      )
    }}
  </MoodTrackerContext.Consumer>
)

export default Reports
